export default function settlementServiceDashboard(fetch, baseUrl) {
  return {
    // Get General Dashboard Config
    getDashboardConfig() {
      return fetch.get(`${baseUrl}/config`);
    },

    // Client Management Endpoints
    getAllClients({ payload }) {
      return fetch.post(`${baseUrl}/client-accounts/search`, payload);
    },

    getClientDetails({ clientId }) {
      return fetch.get(`${baseUrl}/client-accounts/${clientId}`);
    },

    addNewClientSettlement({ payload }) {
      return fetch.post(`${baseUrl}/client-accounts/create`, payload);
    },

    updateClient({ clientId, payload }) {
      return fetch.put(`${baseUrl}/client-accounts/${clientId}`, payload);
    },

    // Ledger Management Endpoints
    getAllLedgers({ payload }) {
      return fetch.post(`${baseUrl}/ledger/search`, payload);
    },

    getLedgerDetails({ ledgerId }) {
      return fetch.get(`${baseUrl}/ledgers/${ledgerId}`);
    },

    getLedgerStatement({ ledgerId, payload }) {
      return fetch.post(`${baseUrl}/ledgers/${ledgerId}/statement`, payload);
    },

    addNewLedgerSettlement({ payload }) {
      return fetch.post(`${baseUrl}/ledger/credit`, payload);
    },

    // Account Operations Endpoints
    getAllAccounts({ payload }) {
      return fetch.post(`${baseUrl}/accounts/search`, payload);
    },

    getAccountDetails({ accountId }) {
      return fetch.get(`${baseUrl}/accounts/${accountId}`);
    },

    addNewAccountSettlement({ payload }) {
      return fetch.post(`${baseUrl}/accounts/create`, payload);
    },

    updateAccountSettlement({ accountId, payload }) {
      return fetch.put(`${baseUrl}/accounts/update/${accountId}`, payload);
    },

    // Additional Account Operations
    getAccountTransactions({ accountId, payload }) {
      return fetch.post(`${baseUrl}/accounts/${accountId}/transactions`, payload);
    },

    updateAccountBalance({ accountId, payload }) {
      return fetch.put(`${baseUrl}/accounts/${accountId}/balance`, payload);
    },
  }
} 